export const EMAIL_OTP = "Email OTP";
export const MAGICLINK = "MAGICLINK"; 